import React from "react";
import { useState, useMemo } from "react";
import { Card, Col, Container, Dropdown, DropdownButton, ListGroup, Modal, Row, Stack, Spinner, Alert, Image } from "react-bootstrap";
import { Button, Dimmer, Divider, Icon, ItemMeta, Label, Loader, Popup, Accordion, Placeholder } from "semantic-ui-react";
import SummaryCart from "../../component/SummaryCart";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore } from '@fortawesome/free-solid-svg-icons';
import { faTruck } from '@fortawesome/free-solid-svg-icons'
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import AddressForm from "../../component/AddressForm";
import { useLocation, useNavigate } from "react-router-dom"
import TimerCountDown from "../../component/TimerCountDown";
import { HiListBullet, HiOutlineBanknotes, HiOutlineCreditCard } from "react-icons/hi2";
import { useMyGlobal } from "../../component/GlobalData";
import { Toast } from "../../component/Toast";
import { formatToK } from "../../component/utility";
import InfoCustomerForm from "../../component/InfoCustomerForm";

const Checkout = ({ cart, setCart, updateNotif, pageLoader, hasMainWarehouse }) => {
    const navigate = useNavigate();
    const ses = window.localStorage
    const [userAddress, setUserAddress] = useState(null)
    const [selectedAddress, setSelectedAddress] = useState(null)
    const [selectedAddressEdit, setSelectedAddressEdit] = useState(null)
    const userProfile = JSON.parse(ses.getItem('profile'))
    const [selKurir, setSelKurir] = useState(null)
    const [modalService, setModalService] = useState(false)
    const [modalWarehouse, setModalWarehouse] = useState('')
    const [service, setService] = useState(null)
    const { token, windowWidth } = useMyGlobal()
    const [hasWarehouse, setHasWarehouse] = useState(true)
    const [isValidCourierClick, setIsValidCourierClick] = useState(false)
    const [totalResi, setTotalResi] = useState(0)
    const [isEnableClickPayment, setIsEnableClickPayment] = useState(false)
    const [isLoadingCart, setIsLoadingCart] = useState(true)
    const [warehouseClicked, setWarehouseClicked] = useState({})
    const [isPickUp, setIsPickUp] = useState(false)
    const [isLoadingPickUp, setIsLoadingPickUp] = useState(false)
    const [pickUpWarehouse, setPickUpWarehouse] = useState('')
    const [isValidResi, setIsValidResi] = useState(false)
    const [modalPayment, setModalPayment] = useState(false)
    const [modalPickUp, setModalPickUp] = useState(false)
    const [courierLoader, setCourierLoader] = useState(false)
    const [paymentSelect, setPaymentSelect] = useState({
        id: '003',
        type: 'Snap Payment (more payment options here)',
        name: 'Multi payment method',
        is_active: 'Y',
        logo: <div style={{ borderRadius: 5, padding: '5px 10px 5px 10px', backgroundColor: 'teal' }}><HiListBullet size={28} /></div>
    })
    const urlGetService = 'http://apiv2.jne.co.id:10102/tracing/api/pricedev'
    const [modalAddress, setModalAddress] = useState(false)
    const [modalAddressEdit, setModalAddressEdit] = useState(false)
    const [modalAddressList, setModalAddressList] = useState(false)
    const [origin, setOrigin] = useState("BDO10054")
    const [totalOrigin, setTotalOrigin] = useState(1)
    const [courierServices, setCourierServices] = useState(null)
    const [courier, setCourier] = useState(null)
    const [selCompleteCourier, setSelCompleteCourier] = useState(null)
    const [addressList, setAddressList] = useState(null)
    const idCustomer = (localStorage.getItem('loginDataRr')) ? JSON.parse(localStorage.getItem('loginDataRr')).id : null
    const [modalLoading, setModalLoading] = useState(false)
    const [paymentRes, setPaymentRes] = useState('')
    const [loadingMsg, setLoadingMsg] = useState('')
    const [payAlert, setPayAlert] = useState(false)
    const [currentTime, setCurrentTime] = useState(null)
    const [orderAddress, setOrderAddress] = useState(null)
    const [orderCourier, setOrderCourier] = useState(null)
    const [addressState, setAddressState] = useState({})
    const [courierOptLabel, setCourierOptLabel] = useState('Available Courier')
    const [addrChange, setAddrChange] = useState(false)
    const [priceJNECalled, setPriceJNECalled] = useState(false)
    const [btnCclState, setBtnCclState] = useState(false)
    const [isLoad, setIsLoad] = useState(false)
    const [cancelLoad, setCancelLoad] = useState(false)
    // const jneAsuransiAdmin = 5000
    const jneAsuransiAdmin = 5000 * totalOrigin
    const jneAsuransiPersen = 0.2
    const [courierPerWarehouse, setCourierPerWarehouse] = useState({})
    const [warehouseDetailData, setWarehouseDetailData] = useState({})
    const [warehouseDetailLoader, setWarehouseDetailLoader] = useState(true)
    const [activeIndices, setActiveIndices] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [disabledClick, setDisabledClick] = useState(false);
    const [isCompletedInputInfo, setIsCompletedInputInfo] = useState(false);
    const [courierListPicked, setCourierListPicked] = useState(false)

    useEffect(() => {
        if (pickUpWarehouse != 0 && pickUpWarehouse !== null && pickUpWarehouse !== '') {
            setIsPickUp(true)
        } else {
            setIsPickUp(false)
        }
    }, [pickUpWarehouse]);

    const unSetAllCourierData = () => {
        setModalPayment(false)
        setCourierLoader(false)
        setTotalResi(0)
        setIsValidCourierClick(false)
        setIsEnableClickPayment(false)
        setCourierPerWarehouse({})
        setWarehouseClicked({})
    }

    const handleAccordionClick = (index) => {
        setActiveIndices((prevIndices) =>
            prevIndices.includes(index)
                ? prevIndices.filter((i) => i !== index) // close
                : [...prevIndices, index] // open
        );
    };

    const handleClickWithDelay = (item, cart, warehouseId, warehouseWeight) => {
        if (disabledClick) {
            // console.log("Click is disabled");
            return;
        }

        // console.log("Click allowed");

        setDisabledClick(true);
        handleClickDropdown(item, cart, warehouseId, warehouseWeight)
        // handleClickDropdown(item, cart);

        setTimeout(() => {
            // console.log("Timeout finished");
            setDisabledClick(false);
        }, 5000); // 5 detik
    };

    const payment = {
        data: [
            {
                id: '001',
                type: 'Bank Transfer',
                name: 'BCA',
                is_active: 'N',
                logo: <div style={{ borderRadius: 5, padding: '5px 10px 5px 10px', backgroundColor: 'lightgray' }}><HiOutlineBanknotes size={28} /></div>
            },
            {
                id: '002',
                type: 'Card Payment',
                name: 'Credit Card',
                is_active: 'N',
                logo: <div style={{ borderRadius: 5, padding: '5px 10px 5px 10px', backgroundColor: 'lightgray' }}><HiOutlineCreditCard size={28} /></div>
            },
            {
                id: '003',
                type: 'Snap Payment (more payment options here)',
                name: 'Multi payment method',
                is_active: 'Y',
                logo: <div style={{ borderRadius: 5, padding: '5px 10px 5px 10px', backgroundColor: 'teal' }}><HiListBullet size={28} /></div>
            },
        ]
    }

    const percentTag = {
        alignItems: 'center',
        background: 'linear-gradient(to right, #00796B, #00B5AD)',
        fontSize: '0.714286rem',
        color: 'rgb(255, 255, 255)',
        fontWeight: 600,
        fontSize: '0.714286rem',
        borderRadius: '0 0 5px 0px',
    }

    const percentTagNormal = {
        alignItems: 'center',
        background: 'linear-gradient(to right, grey, lightgrey)',
        fontSize: '0.714286rem',
        color: 'rgb(255, 255, 255)',
        fontWeight: 600,
        fontSize: '0.714286rem',
        borderRadius: '0 0 5px 0px',
    }

    const showPayAlert = () => (setPayAlert(true))
    const hidePayAlert = () => (setPayAlert(false))

    const loadingShow = () => (setModalLoading(false))
    const loadingClose = () => (setModalLoading(true))

    const handleClose = () => (setModalService(false), setCourierListPicked(false))
    const handleShow = () => (setModalService(true))

    const closePay = () => (setModalPayment(false))
    const showPay = () => (setModalPayment(true))

    const closePickUp = () => (setModalPickUp(false))
    const showPickUp = () => (setModalPickUp(true))

    const closeAddressForm = () => (setModalAddress(false))
    const showAddressForm = () => (setModalAddress(true))

    const closeAddressFormEdit = () => (setModalAddressEdit(false))
    const showAddressFormEdit = () => (setModalAddressEdit(true))

    const closeAddressList = () => (setModalAddressList(false))
    const showAddressList = () => (setModalAddressList(true))

    const setUsedAddress = (list, idAddr) => {
        const addr = list && list.filter(i => i.id_address == idAddr)[0]
        // sessionStorage.setItem('address', JSON.stringify(addr))
        setUserAddress(addr)
        setSelectedAddress(addr)
        cart.customer.address = addr
        setCart(cart)
    }

    const updateQtyInc = (idOrder) => {
        let param = cart.products

        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/order.php/?index=15&id_order=${idOrder}`,
            headers: {
                'Content-Type': 'text/plain',
                'Authorization': token
            },
            data: param
        })
            .then(res => {

            })
    }

    // const capitalizeWords = (str) => {
    //     return str
    //         .toLowerCase()
    //         .split(' ')
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    //         .join(' ');
    // };

    const capitalizeWords = (str) => {
        const words = str.trim().toLowerCase().split(/\s+/);
        let result = '';

        for (let word of words) {
            const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
            if ((result + capitalizedWord + ' ').length > 26) break;
            result += capitalizedWord + ' ';
        }

        return result.trim();
        // return str
        //     .toLowerCase()
        //     .split(' ')
        //     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        //     .join(' ');
    };

    function formatIndonesianCity(name) {
        if (/^Kota\s+/i.test(name)) {
            return name.replace(/^Kota\s+/i, '') + ' City';
        }
        if (/^Kabupaten\s+/i.test(name)) {
            return name.replace(/^Kabupaten\s+/i, '') + ' Regency';
        }
        return name;
    }

    const handleCancel = (idCust) => {
        const param = new URLSearchParams()
        const idC = cart.summary.id_cart
        const idO = cart.summary.order_id

        param.append('id_customer', idCust)
        param.append('id_cart', idC)
        param.append('status', 'CANCEL BEFORE PAYMENT')
        param.append('status_code', '3')
        param.append('id_order', idO)
        let msg = "Are you sure want to cancel this order?"
        if (window.confirm(msg) === true) {
            setCancelLoad(true)
            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=6`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.state == 200) {
                        setBtnCclState(true)
                        if (!btnCclState) {
                            // updateQtyInc(idO) // BALIKIN QTY PRODUK
                            cartProduct(idCust)
                            updateNotif(idCust)
                            deleteResi(idO)
                            navigate('/')
                            Toast.fire({
                                icon: 'success',
                                title: 'This order has been canceled...'
                            })
                            setCancelLoad(false)
                        }
                    } else {
                        alert(response.data.message)
                        setCancelLoad(false)
                    }
                })
        } else {
            setCancelLoad(false)
        }
    }

    // const handleClickDropdown = (item, cart) => {
    //     if (cart.products.length === 0) {
    //         alert('there are no products in the cart')
    //     } else if (!cart.customer.address) {
    //         alert('there are no address selected, Please add address before selecting courier')
    //     } else {
    //         setSelKurir(item);
    //         courierPriceJNE(cart.summary.total_weight, cart.customer.address ? cart.customer.address.cost_code : userAddress.cost_code, item.id_courier)
    //         // localStorage.setItem('selKurir', JSON.stringify(item))
    //         // setService(item.name[0])
    //         // localStorage.setItem('service', JSON.stringify(item.service[0]))
    //         // localStorage.setItem('kurir', JSON.stringify(item))
    //         handleShow()
    //     }
    // }

    useEffect(() => {
        getWarehouseDetail()
        cartProduct(idCustomer)
        getCart()
    }, []);



    const getWarehouseDetail = async () => {
        await axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/cart.php/?index=22`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token

            },
        })
            .then((response) => {
                if (response.data.state == 200) {
                    let data = response.data.data
                    setWarehouseDetailData(data)
                }
                setWarehouseDetailLoader(false)
            })
            .catch((error) => console.log(error.response.state))
        setWarehouseDetailLoader(false)
    }

    useEffect(() => {
        let isValid = totalResi === totalOrigin
        setIsValidResi(isValid)
    }, [totalOrigin, totalResi]);

    const handleClickDropdown = (item, cart, warehouseId, warehouseWeight) => {
        if (cart.products.length === 0) {
            alert('there are no products in the cart')
        } else if (!cart.customer.address) {
            alert('there are no address selected, Please add address before selecting courier')
        } else if (warehouseId === null || warehouseWeight === null || warehouseWeight <= 0) {
            alert('data is in progress, please be waiting for some minutes')
        } else {
            // console.log(warehouseWeight)
            setCourierServices(null)
            const newState = {
                ...courierPerWarehouse,
                [warehouseId]: {
                    "price": 0,
                    "id_courier": item.id_courier,
                    "courier_name": item.name,
                    "service_code": null,
                    "service_display": null,
                    "is_clicked": false,
                    "alias": warehouseDetailData[warehouseId].alias,
                    "qty": 0,
                    "weight": 0,
                    "id_warehouse": warehouseId,
                    "total_price": 0,
                    "shipping_insurance": 0
                }
            };
            setCourierPerWarehouse(newState)

            setWarehouseClicked(prev => {
                const newState = { ...prev };
                delete newState[warehouseId];
                return newState;
            });
            setTotalResi(0)

            setSelKurir(item);
            // // courierPriceJNE(cart.summary.total_weight, cart.customer.address ? cart.customer.address.cost_code : userAddress.cost_code, item.id_courier)
            courierPriceJNE(warehouseWeight, cart.customer.address ? cart.customer.address.cost_code : userAddress.cost_code, item.id_courier, warehouseId)
            // // localStorage.setItem('selKurir', JSON.stringify(item))
            // // setService(item.name[0])
            // // localStorage.setItem('service', JSON.stringify(item.service[0]))
            // // localStorage.setItem('kurir', JSON.stringify(item))
            setModalWarehouse(warehouseId)
            handleShow()
        }
    }

    const summarizeCourierData = (courierPricePerWarehouse = {}) => {
        let totalPrice = 0;
        const serviceCodes = new Set();
        const serviceDisplay = new Set();

        const allClicked = Object.values(courierPricePerWarehouse).every(
            ({ is_clicked }) => is_clicked === true
        );

        Object.values(courierPricePerWarehouse).forEach(({ price, service_code, service_display }) => {
            totalPrice += Number(price) || 0;
            if (service_code) serviceCodes.add(service_code);
            if (service_display) serviceDisplay.add(service_display);
        });

        return {
            price: totalPrice,
            service_code: Array.from(serviceCodes).join(', '),
            service_display: Array.from(serviceDisplay).join(', '),
            all_clicked: allClicked
        };
    };
    
    const handleClickService = (item, cart, warehouseId) => {
        setService(item)
        // setSelCompleteCourier({
        //     courier: selKurir,
        //     service: item
        // })
      
        const newState = {
            ...courierPerWarehouse,
            [warehouseId]: {
                "price": item.price,
                "id_courier": courierPerWarehouse[warehouseId].id_courier,
                "courier_name": courierPerWarehouse[warehouseId].courier_name,
                "service_code": item.service_code,
                "service_display": item.service_display,
                "is_clicked": true,
                "alias": warehouseDetailData[warehouseId].alias,
                "qty": warehouseQty[warehouseId],
                "weight": warehouseWeight[warehouseId],
                "id_warehouse": warehouseId,
                "total_price": warehousePrice[warehouseId],
                "shipping_insurance": Math.ceil(((warehousePrice[warehouseId] * jneAsuransiPersen) / 100)) + 5000
            }
        };

        // console.log(warehousePrice[warehouseId])

        setCourierPerWarehouse(newState);

        const result = summarizeCourierData(newState)

        // handleClose();

        // setSelCompleteCourier({
        //     courier: selKurir,
        //     service: item
        // })
        setSelCompleteCourier({
            courier: selKurir,
            service: result
        })

        const selectedWarehouse = {
            ...warehouseClicked,
            [warehouseId]: true
        }

        setWarehouseClicked(selectedWarehouse)


        // if (isValidCourierClick) {
        //     updateOrderCourier(
        //         cart.summary.order_id,
        //         {
        //             courier: selKurir,
        //             service: result
        //         }, 
        //         selectedAddress
        //     )
        //     cart.summary.kurir = (selKurir) && selKurir.id_courier;
        //     // cart.summary.service = item.service_code;
        //     cart.summary.service = result.service_code;
        //     cartProduct(idCustomer)
        // }
        setCourierListPicked(true)
    }

    useEffect(() => {
        if (isValidCourierClick && selCompleteCourier) {
            const { courier, service } = selCompleteCourier;
            const payload = {
                courier: courier,
                service: service
            }
            updateOrderCourier(
                cart.summary.order_id,
                payload,
                selectedAddress
            );

            updateResi(cart.summary.order_id, courierPerWarehouse)

            cart.summary.kurir = courier?.id_courier;
            cart.summary.service = service?.service_code;
            cartProduct(idCustomer);
        }
    }, [isValidCourierClick]);


    // const SelectedCourier = ({ kurir, selService }) => {
    //     if (kurir && selService) {
    //         setCourierOptLabel('Change Courier')
    //         return (
    //             <section className="mt-2">
    //                 <div className="fw-bold">Selected Courier</div>
    //                 <div className="text-muted">{kurir.name}</div>
    //                 <div className="fw-bold">Service</div>
    //                 <div className="text-muted d-flex justify-content-between">
    //                     {(cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0 && selService.price > cart.summary.voucher_ongkir) ?
    //                         <span>{(selService) ? selService.service_display : <></>} &nbsp;&nbsp; {(selService) ? global.IDR.format(selService.price - cart.summary.voucher_ongkir) : <></>}</span>
    //                         :
    //                         (cart.summary.voucher_ongkir > 0 && selService.price < cart.summary.voucher_ongkir) ?
    //                             <span>{(selService) ? selService.service_display : <></>} &nbsp;&nbsp; {(selService) ? global.IDR.format(selService.price - selService.price) : <></>}</span>
    //                             :
    //                             <span>{(selService) ? selService.service_display : <></>} &nbsp;&nbsp; {(selService) ? global.IDR.format(selService.price) : <></>}</span>
    //                     }
    //                     {/* <span className="fw-bold" onClick={handleShow} style={{ cursor: 'pointer' }}>Change</span> */}
    //                 </div>
    //             </section>
    //         )
    //     } else {
    //         const fkurir = orderCourier
    //         setCourierOptLabel('Available Courier')
    //         if (fkurir) {

    //             return (
    //                 <section className="mt-2">
    //                     <div className="fw-bold">Selected Courier</div>
    //                     <div className="text-muted">{fkurir.name}</div>
    //                     <div className="fw-bold">Service</div>
    //                     <div className="text-muted d-flex justify-content-between">
    //                         {
    //                             <span>{fkurir.service_display} &nbsp;&nbsp; Rp {fkurir.courier_cost}</span>
    //                         }

    //                         {/* <span className="fw-bold" onClick={() => alert('ssss')} style={{ cursor: 'pointer' }}>Change</span> */}
    //                     </div>
    //                 </section>
    //             )
    //         } else {
    //             <></>
    //         }
    //     }
    // }

    useEffect(() => {
        if (cart.summary.kurir !== null) {
            setCourierOptLabel('Change Courier')
        } else if (cart.summary.kurir == null) {
            setCourierOptLabel('Available Courier')
        }
    }, [selKurir, cart])

    const setDefaultAddress = (idAddress, status) => {
        const param = new URLSearchParams();

        param.append('id_address', idAddress);
        param.append('status', status)
        param.append('id_customer', idCustomer)

        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/customer.php/?index=4`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state === 200) {
                    getCustomerAddress(idCustomer)
                }
            })
    }


    const getActiveCourier = async () => {
        await axios({
            method: "GET",
            url: `${global.SRV}api_rudrunner/controler/courier.php/?index=2`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        })
            .then((response) => {
                if (response.data.length > 0) {
                    if (response.data !== courier) {
                        setCourier(response.data)
                    }
                    // setSelKurir(response.data.filter(i => i.id_courier == cart.summary.kurir)[0])
                } else {
                    setCourier(null)
                    // setSelKurir(null)
                }
            })
    }

    const getCustomerAddress = async (idCustomer) => {
        const param = new URLSearchParams()
        param.append('id_customer', idCustomer)

        await axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/customer.php/?index=3`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state === 200) {
                    setAddressList(response.data.data)
                    // setOrigin(response.data.data.filter(i => i.isDefault == 1)[0].cost_code)
                    if (cart.customer.address !== null) {
                        if (!orderAddress) {
                            setUserAddress(cart.customer.address)
                        } else {
                            setUserAddress(orderAddress)
                        }
                    } else if (cart.customer.address === null) {
                        if (!orderAddress) {
                            setUserAddress(response.data.data.filter(i => i.isDefault == 1)[0])
                        } else {
                            setUserAddress(orderAddress)
                        }
                    }
                }
            })
    }

    const clearKurir = (id_order) => {
        const param = new URLSearchParams()
        param.append("id_order", id_order)

        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/order.php/?index=9`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then(response => {

            })
    }

    const updateOrderAddress = (orderId, address) => {
        if (orderId && address) {
            const param = new URLSearchParams()
            param.append('id_order', orderId)
            param.append('id_address', address)

            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=2`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    clearKurir(orderId)
                    cart.summary.kurir = null
                    cart.summary.service = null
                    cart.summary.service_cost = 0
                    cart.summary.total_order = (cart.summary.totalPrice + cart.summary.service_cost) - cart.summary.voucher
                    setService(null)
                    setSelCompleteCourier(null)
                    setCart(cart)
                })
        } else {
            Toast.fire({
                icon: 'warning',
                title: 'Parameter not completed'
            })
        }
    }

    const updateResi = (orderId, data) => {
        if (orderId !== null && data !== null) {
            setIsLoadingCart(true)
            const param = new URLSearchParams()
            param.append('id_order', orderId)
            const jsonString = JSON.stringify(data);
            param.append('warehouse_data', jsonString)

            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=18`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    console.log(response.data)
                    setTotalResi(response.data.data.total_updated)
                    setIsLoadingCart(false)
                })
                .finally(() => {
                    setIsLoadingCart(false)
                });
        } else {
            Toast.fire({
                icon: 'warning',
                title: 'Parameter not fillfiled'
            })
        }
    }

    const deleteResi = (orderId) => {
        if (orderId !== null) {
            const param = new URLSearchParams()
            param.append('id_order', orderId)

            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=19`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    console.log(response.data)
                })
                .finally(() => {
                    // setIsLoadingCart(false)
                });
        } else {
            Toast.fire({
                icon: 'warning',
                title: 'Parameter not fillfiled'
            })
        }
    }

    const updateOrderCourier = (orderId, courier, address) => {
        if (orderId !== null && courier !== null && address !== null) {
            // setIsLoadingCart(true)
            const asuransi = Math.ceil(((cart.summary.totalPrice * jneAsuransiPersen) / 100)) + jneAsuransiAdmin
            const param = new URLSearchParams()
            param.append('id_order', orderId)
            param.append('id_courier', (courier.courier) ? courier.courier.id_courier : courier.id_courier)

            if (cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0 && courier.service?.price > cart.summary.voucher_ongkir) {
                param.append('courier_cost', courier.service?.price - cart.summary.voucher_ongkir)
            } else if (cart.summary.voucher_ongkir > 0 && courier.service?.price < cart.summary.voucher_ongkir) {
                param.append('courier_cost', courier.service?.price - courier.service?.price)
            } else {
                param.append('courier_cost', courier.service?.price)
            }

            param.append('courier_service', courier.service?.service_code)
            param.append('id_address', address.id_address)
            param.append('asuransi', asuransi)
            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=2`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    console.log(response)
                    // setIsLoadingCart(false)
                })
                .finally(() => {
                    // setIsLoadingCart(false)
                });
        } else {
            Toast.fire({
                icon: 'warning',
                title: 'Parameter not fillfiled'
            })
            setSelCompleteCourier(null)
        }
    }

    const SpinerGrow = () => {
        return <Spinner animation="grow" />;
    }

    const createPaymentCC = (customer) => {
        const orderId = cart.summary.order_id

        navigate('/checkout/paymentCard', {
            state: {
                order_id: orderId,
                customer_id: customer
            }
        })
    }

    const createSnapPay = async (customer) => {
        const param_snap = new URLSearchParams()
        param_snap.append('id_customer', customer)
        param_snap.append('shipping_data', JSON.stringify(courierPerWarehouse))
        setIsLoad(true)

        const updateStateCartSnap = () => {
            const param = new URLSearchParams()
            param.append('id_order', cart.summary.order_id)
            param.append('id_cart', cart.summary.id_cart)
            param.append('total_voucher', cart.summary.voucher)
            param.append('state', 3)
            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=4`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.state == 200) {
                        cart.is_ordered = response.data.data // SET STATUS CART JADI 3
                        setCart(cart)
                    }
                })
        }

        if (customer) {
            await axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/payment.php/?index=10`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param_snap
            })
                .then(res => {
                    if (res.data.token) {
                        if (res.data.redirect_url) {
                            updateStateCartSnap()
                            window.location.replace(res.data.redirect_url)
                            setIsLoad(false)
                        } else {
                            Toast.fire({
                                icon: "error",
                                text: "Redirect url not found, contact Customer Service",
                                position: "center"
                            })
                            setIsLoad(false)
                        }
                    } else {
                        Toast.fire({
                            icon: "error",
                            text: res.data.error_messages,
                            showCloseButton: true,
                            timer: null,
                            timerProgressBar: false,
                            showConfirmButton: false,
                            position: 'center'
                        })
                        setIsLoad(false)
                    }
                })
        } else {
            Toast.fire({
                icon: 'error',
                text: "You'r not login or id customer not identify, try to relogin",
                position: "center"
            })
        }
    }


    const createPayment = (customer) => {

        const param = new URLSearchParams()
        const param2 = new URLSearchParams()

        param.append('id_order', cart.summary.order_id)
        param.append('id_cart', cart.summary.id_cart)
        param.append('total_voucher', cart.summary.voucher)
        param.append('state', 2)
        param2.append('id_customer', customer)

        setModalLoading(true)
        setLoadingMsg('Please wait, the payment process is loaded')
        closePay()

        const updateStateCart = () => {
            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/order.php/?index=4`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.state == 200) {
                        cart.is_ordered = response.data.data // SET STATUS CART JADI 2
                        setCart(cart)
                    }
                })
        }

        const orderConfirmationMail = (payment) => {
            // let param = new URLSearchParams();


            // param.append("to", cart.customer.email)
            // param.append("to_name", cart.customer.first_name + ' ' + cart.customer.last_name)
            // param.append("subject", "Order Confirmation")
            // param.append("content", cart) // DIKIRIM SELALU JADI STRING DI PHP
            // param.append("page", '../email/orderInfo.html')
            cart.courier_detail = orderCourier
            cart.payment = payment
            const param = {
                to: cart.customer.email,
                to_name: cart.customer.first_name + ' ' + cart.customer.last_name,
                subject: "Order Confirmation",
                content: cart,
                page: '../email/orderInfo.html'
            }

            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/email.php/?index=2`,
                headers: {
                    'Content-Type': 'text/plain',
                    'Authorization': token
                },
                data: param
            }).then(res => {

            })
        }

        // CREATE PAYMENT
        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/payment.php/?index=1`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param2
        })
            .then(response => {

                if (response.data) {
                    setModalLoading(false)
                    if (response.data) {
                        if (response.data.response_api.status_code == 201) {
                            updateStateCart()
                            updateNotif(idCustomer)
                            setPayAlert(false)
                            // orderConfirmationMail(response.data.response_api) UDAH ADA EMAIL DARI MIDTRANS
                            navigate('/cart/checkout/payment',
                                {
                                    state: { 'summary': cart.summary.order, 'response': response.data.response_api }
                                }
                            )
                        } else {
                            setPaymentRes(response.data.response_api.status_message)
                            setPayAlert(true)
                        }
                    }
                }
            })

    }

    const getCart = async () => {
        const param = new URLSearchParams()
        param.append('id_customer', idCustomer)
        setIsLoadingPickUp(true)
        await axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/cart.php/?index=6`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state == 200) {
                    setPickUpWarehouse(response.data.data.isPickUp)
                }
            })
            .finally(() => {
                setIsLoadingPickUp(false)
            });

    }

    const cartProduct = async (idCustomer) => {
        const param = new URLSearchParams()
        param.append('id_customer', idCustomer)
        setIsLoadingCart(true)
        await axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/cart.php/?index=5`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state == 200) {
                    setCart(response.data.data)
                }
                const hasWarehouse = response.data.data.products.every(det => det.hasOwnProperty('id_warehouse') && det.id_warehouse);
                setHasWarehouse(hasWarehouse)
                setIsLoadingCart(false)
            })
            .finally(() => {
                setIsLoadingCart(false)
            });

    }

    useEffect(() => {
        if (!isLoadingCart && isValidResi && isValidCourierClick) {
            setIsEnableClickPayment(true)
        } else {
            setIsEnableClickPayment(false)
        }
    }, [isLoadingCart, isValidResi, isValidCourierClick]);


    useEffect(() => {
        const validateAddingAddress = async (idCust) => {
            const param = new URLSearchParams()
            param.append('id_customer', idCust)

            await axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/customer.php/?index=10`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(res => {
                    if (res.data.state === 200) {
                        setAddressState(res.data.data)
                    }
                })
        }

        if (cart.customer.id_customer || idCustomer) {
            getCustomerAddress(idCustomer || cart.customer.id_customer)
            validateAddingAddress(idCustomer || cart.customer.id_customer)
        } else {
            navigate('/')
        }
    }, [cart, idCustomer])

    const courierPriceJNE = async (wg, thru, idCourier, idWarehouse) => {
        if (parseFloat(wg) > 0) {
            setCourierServices(null)
            setCourierLoader(true)
            const param = new URLSearchParams()
            param.append('weight', parseFloat(wg))
            // param.append('from', origin)
            param.append('id_warehouse', idWarehouse)
            param.append('thru', thru)
            param.append('id_courier', idCourier)
            await axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/courier.php/?index=5`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.status !== false) {
                        if (response.data !== courierServices) {
                            setPriceJNECalled(true)
                            // setCourierServices(response.data);
                            setCourierServices({ ...response.data, id_warehouse: idWarehouse });

                        }
                        setCourierLoader(false)
                    }
                })
        } else {
            alert(`Unaccepted weight ${wg}, try to reload this page.`)
            // alert(`Unaccepted parameters, try to reload this page or keep waiting for some minutes`)
        }
    }

    const getOrderAddress = async (idOrder) => {
        const param = new URLSearchParams
        param.append('id_order', idOrder)

        await axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/order.php/?index=10`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then(response => {
                if (response.data.state === 200) {
                    if (orderAddress !== response.data.data) {
                        setOrderAddress(response.data.data)
                    }
                }
            })
    }

    const getOrderKurir = async (idOrder) => {
        const param = new URLSearchParams()
        param.append('id_order', idOrder)

        await axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/order.php/?index=11`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then(response => {
                if (response.data.state === 200) {
                    if (orderCourier !== response.data.data) {
                        setOrderCourier(response.data.data)
                    }
                }
            })
    }

    const multipleDiscLabel = (item) => {
        const multiDiscData = item?.multiple_disc_price > 0 && item?.multiple_disc_label !== "";
        if (!multiDiscData) return undefined;
        return <Label size='mini' style={percentTag}>{`${item?.multiple_disc_label}`}</Label>
    }


    const calcDiscPercent = (item) => {
        if (item.discount.id_discount && !item.fs_on) {
            return <Label size="mini" style={percentTag}>
                {item.discount.discount_text !== '' && item.discount.discount_text !== null && item.discount.discount_text !== 'null' ? item.discount.discount_text : item.discount.discount_type === 'nominal' ? `${global.IDR.format(item.discount.discount_value)}` : `${Math.ceil(item.discount.discount_value)}%`}
            </Label>
        } else if (item.discount == null && item.fs_on && item.fs_type === 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : global.IDR.format(item.fs_nominal)}</Label>
        } else if (item.discount == null && item.fs_on && item.fs_type !== 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : `${Math.ceil(item.fs_discount)}%`}</Label>
        } else if (item.discount !== null && item.fs_on && item.fs_type === 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : global.IDR.format(item.fs_nominal)}</Label>
        } else if (item.discount !== null && item.fs_on && item.fs_type !== 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : `${Math.ceil(item.fs_discount)}%`}</Label>
        } else if (item.fs_on && item.fs_type === 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : global.IDR.format(item.fs_nominal)}</Label>
        } else if (item.fs_on && item.fs_type !== 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : `${Math.ceil(item.fs_discount)}%`}</Label>
        } else if (item.fs_on && item.is_discounted == '1' && item.fs_type === 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : global.IDR.format(item.fs_nominal)}</Label>
        } else if (item.fs_on && item.is_discounted == '1' && item.fs_type !== 'N') {
            return <Label size='mini' style={percentTag}>{item.fs_text !== '' && item.fs_text !== null && item.fs_text !== 'null' ? item.fs_text : `${Math.ceil(item.fs_discount)}%`}</Label>
        } else if (item.discount == null && !item.fs_on && item.is_discounted == '0') {
            return 0
        } else if (!item.fs_on && item.is_discounted == '0') {
            if (item.multiple_disc_price > 0) return undefined;
            return <Label size='mini' style={percentTagNormal}>No Dscn.</Label>
        } else {
            return undefined
        }

    }

    const calcDiscValue = (item) => {
        if (item.discount.id_discount && !item.fs_on) {
            return global.IDR.format(item.discount.discount_total)
        } else if (item.discount == null && item.fs_on) {
            return item.fs_discount_value ? global.IDR.format(item.fs_discount_value) : global.IDR.format((item.price * item.fs_discount) / 100)
        } else if (item.discount !== null && item.fs_on) {
            return item.fs_discount_value ? global.IDR.format(item.fs_discount_value) : global.IDR.format((item.price * item.fs_discount)) / 100
        } else if (item.fs_on) {
            return item.fs_discount_value ? global.IDR.format(item.fs_discount_value) : global.IDR.format((item.price * item.fs_discount)) / 100
        } else if (!item.fs_on && item.is_discounted == '0') {
            return global.IDR.format(0)
        } else if (item.discount == null && !item.fs_on && item.is_discounted == '0') {
            return 0
        } else if (item.discount == null && !item.fs_on) {
            return 0
        } else {
            return undefined
        }
    }

    const priceCoret = (item) => {
        if (item.fs_on && item.is_discounted == '1') {
            return <s>{global.IDR.format(item.price)}</s>
        } else if (item.discount.dicount_value > 0) {
            return <s>{global.IDR.format(item.price)}</s>
        } else if (item.fs_on && item.is_discounted == '0') {
            return <s>{global.IDR.format(item.price)}</s>
        } else if (!item.fs_on && item.is_discounted == 1 && item.discount.dicount_value == 0) {
            return ''
        }
    }

    const LabelVoucher = () => {
        if (service) {
            // if (cart.summary.voucher_ongkir > 0 && service.price > cart.summary.voucher_ongkir) {
            // if (cart.summary.voucher_ongkir > 0 && selCompleteCourier.service.price > cart.summary.voucher_ongkir) {
            //     return "-" + global.IDR.format(cart.summary.voucher_ongkir)
            // } else {
            if (cart.selected_voucher.length > 0) {
                const voucher = cart.selected_voucher.find(v => v.type === 'O' || v.discount_type === 'O')
                const voucherName = (voucher && voucher.name) || null
                const voucherNominal = (voucher && voucher.nominal) || null
                if (voucherName && voucherNominal) {
                    return (
                        <Popup
                            position="bottom center"
                            content="You have applied this voucher"
                            trigger={
                                <Label tag size="small" color="teal">{voucherName + ' ' + formatToK(voucherNominal)}</Label>
                            }
                        />
                    )
                }
            }
            // }
        }
    }

    const handleClickProduct = (item) => {
        navigate(`/product/${item.product_id}`)
    }

    // useEffect(() => {
    //     if (cart.customer.address !== null) {
    //         if (parseFloat(cart.summary.total_weight) > 0) {
    //             if (!priceJNECalled) {
    //                 let total_weight = 0
    //                 total_weight = cart.products.reduce((total, item) => total + parseInt(item), 0)
    //                 courierPriceJNE(cart.summary.total_weight, cart.customer.address.cost_code, selKurir ? selKurir.id_courier : cart.summary.kurir)
    //             }
    //         } else {
    //             Toast.fire({
    //                 icon: "warning",
    //                 text: `Weight of item can't be : ` + parseInt(cart.summary.total_weight),
    //                 position: "center"
    //             })
    //             setSelCompleteCourier(null)
    //             setSelKurir(null)
    //             setUserAddress(cart.customer.address)
    //             // localStorage.removeItem('service')
    //         }
    //     } else if (userAddress) {
    //         if (parseFloat(cart.summary.total_weight) > 0) {
    //             courierPriceJNE(cart.summary.total_weight, userAddress.cost_code, selKurir ? selKurir.id_courier : cart.summary.kurir)
    //         }

    //     }
    // }, [cart, userAddress])

    useEffect(() => {
        if (!orderAddress || addrChange) {
            setAddrChange(false)
            getOrderAddress(cart.summary.order_id)
        }
        getActiveCourier();
        if (orderAddress) {
            setUsedAddress(addressList, orderAddress.id_address)
        } else if (userAddress) {
            setUsedAddress(addressList, userAddress.id_address)
        }
    }, [userAddress, cart, orderAddress, addrChange, addressList])

    useEffect(() => {
        getOrderKurir(cart.summary.order_id);
    }, [cart, orderAddress, addrChange])

    useEffect(() => {
        if (courierServices) {
            setSelCompleteCourier({
                courier: (selKurir) ? selKurir : orderCourier,
                service: courierServices.price.filter(i => i.service_code === cart.summary.service)[0]
            })
            setService(courierServices.price.filter(i => i.service_code === cart.summary.service)[0])
        }
    }, [courierServices, selKurir])

    // useEffect(() => { // CANCEL IF EXPIRE TIME HAS MEET
    //     const cancelOnExpire = (idCus) => {
    //         setCancelLoad(true)
    //         const param = new URLSearchParams()
    //         const idC = cart.summary.id_cart
    //         const idO = cart.summary.order_id

    //         param.append('id_customer', idCus)
    //         param.append('id_cart', idC)
    //         param.append('status', 'ORDER TIME EXPIRED')
    //         param.append('status_code', '9')
    //         param.append('id_order', idO)
    //         param.append('timer', currentTime)

    //         axios({
    //             method: "POST",
    //             url: `${global.SRV}api_rudrunner/controler/order.php/?index=6`,
    //             headers: {
    //                 'Content-Type': 'application/x-www-form-urlencoded',

    //             },
    //             data: param
    //         })
    //             .then(response => {
    //                 if (response.data.state == 200) {
    //                     updateQtyInc(idO) // BALIKIN QTY PRODUK
    //                     cartProduct(idCus)
    //                     navigate("/checkout/orderExpirePage", { state: cart })
    //                     setCart(cart)
    //                     updateNotif(idCus)
    //                 }
    //                 setCancelLoad(false)
    //             })
    //     }

    //     if (currentTime !== null && currentTime == 0 && typeof currentTime != 'undefined') {
    //         try {
    //             cancelOnExpire(idCustomer)
    //             // cartProduct(idCustomer)
    //         } catch (e) { console.log(e) }
    //     }

    // }, [])

    // const cancelOnExpire = (idCus) => {
    //     const param = new URLSearchParams()
    //     const idC = cart.summary.id_cart
    //     const idO = cart.summary.order_id

    //     param.append('id_customer', idCus)
    //     param.append('id_cart', idC)
    //     param.append('status', 'ORDER TIME EXPIRED')
    //     param.append('status_code', '9')
    //     param.append('id_order', idO)

    //     axios({
    //         method: "POST",
    //         url: `${global.SRV}api_rudrunner/controler/order.php/?index=6`,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded',
    //             'Authorization': token
    //         },
    //         data: param
    //     })
    //         .then(response => {
    //             if (response.data.state == 200) {
    //                 updateQtyInc() // BALIKIN QTY PRODUK
    //                 cartProduct(idCus)
    //                 // navigate('/')
    //                 setCart(cart)
    //                 updateNotif(idCus)
    //                 navigate("/checkout/orderExpirePage", { state: cart })
    //             }
    //         })
    // }

    const handleHideCourier = () => {
        if (courierServices.price.length > 0) {
            if (typeof selCompleteCourier.service === 'object') {
                if (selCompleteCourier.courier && selCompleteCourier.service) {
                    handleClose()
                    setCourierListPicked(false)
                } else {
                    Toast.fire({
                        icon: 'error',
                        text: 'Please choose one of the couriers first...'
                    })
                }
            } else {
                Toast.fire({
                    icon: 'error',
                    text: 'Please choose one of the couriers first...'
                })
            }
        } else {
            alert("There is no courier to the address you chose, please choose another address...")
            handleClose()
        }
        // (selCompleteCourier) ? (selCompleteCourier.courier && selCompleteCourier.service) ? handleClose : null : null
    }

    useEffect(() => {
        if (cart.is_ordered == '0') {
            alert("This order has been expired...")
            navigate('/')
        }
    }, [cart.id_ordered])

    // const groupedProducts = useMemo(() => {
    //     return cart.products.reduce((acc, item) => {
    //         const warehouse = item.id_warehouse;
    //         if (!acc[warehouse]) {
    //             acc[warehouse] = [];
    //         }
    //         acc[warehouse].push(item);
    //         return acc;
    //     }, {});
    // }, [cart.products]);

    const groupedProducts = useMemo(() => {
        const grouped = cart.products.reduce((acc, item) => {
            const warehouse = item.id_warehouse;
            if (!acc[warehouse]) {
                acc[warehouse] = [];
            }
            acc[warehouse].push(item);
            return acc;
        }, {});

        // set WH0006 to the first index
        const sorted = Object.entries(grouped).sort(([a], [b]) => {
            if (a === 'WH0006') return -1;
            if (b === 'WH0006') return 1;
            return a.localeCompare(b);
        });

        return Object.fromEntries(sorted);
    }, [cart.products]);

    useEffect(() => {
        const indices = Object.keys(groupedProducts).map((_, idx) => idx);
        setActiveIndices(indices);
    }, [groupedProducts]);

    useEffect(() => {
        let isValid = false
        const countWarehouses = Object.keys(groupedProducts).length;
        const countSelectedWarehouses = Object.keys(warehouseClicked).length;
        // const countSelectedWarehouses = totalResi;

        isValid = countWarehouses === countSelectedWarehouses

        setIsValidCourierClick(isValid)

    }, [groupedProducts, warehouseClicked]);

    useEffect(() => {
        const countWarehouses = Object.keys(groupedProducts).length;
        setTotalOrigin(countWarehouses)
    }, [groupedProducts])

    const warehouseWeight = useMemo(() => {
        return cart.products.reduce((acc, item) => {
            const warehouse = item.id_warehouse;
            const weight = item.product_dimension.weight || 0;
            if (!acc[warehouse]) acc[warehouse] = 0;
            acc[warehouse] += weight * item.qty;
            return acc;
        }, {});
    }, [cart.products]);

    const warehousePrice = useMemo(() => {
        return cart.products.reduce((acc, item) => {
            const warehouse = item.id_warehouse;
            const finalPrice = item.multiple_disc_price > 0 ? item.multiple_disc_price : item.final_price || 0;
            if (!acc[warehouse]) acc[warehouse] = 0;
            acc[warehouse] += finalPrice * item.qty || 0;
            return acc;
        }, {});
    }, [cart.products]);

    // useEffect(() => {
    //     console.log("Total Price Per Warehouse:", warehousePrice);
    // }, [warehousePrice]);


    const warehouseQty = useMemo(() => {
        return cart.products.reduce((acc, item) => {
            const warehouse = item.id_warehouse;
            if (!acc[warehouse]) acc[warehouse] = 0;
            acc[warehouse] += item.qty || 0;
            return acc;
        }, {});
    }, [cart.products]);

    return (
        <section>
            {(cart) ? (
                <Container fluid='sm' style={{ marginTop: '4em' }}>
                    <Dimmer active={pageLoader || warehouseDetailLoader} inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                    <Modal show={modalLoading} backdrop='static' keyboard={false} centered>
                        <Modal.Body>
                            <Row className="p-5">
                                <Col md={12} className="d-flex justify-content-center align-self-middle">
                                    <div className="mb-3"><SpinerGrow /></div>
                                </Col>
                                <Col md={12} className="d-flex justify-content-center align-self-middle">
                                    <div className="mb-3 fs-5">{loadingMsg}</div>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>
                    <Modal show={modalAddressEdit} onHide={closeAddressFormEdit} backdrop='static' keyboard='false' centered>
                        <Modal.Header closeButton>Edit Shipping Address</Modal.Header>
                        <Modal.Body>
                            <AddressForm
                                showModal={setModalAddressEdit}
                                getUserAddress={getCustomerAddress}
                                isFirstAddress={false}
                                editData={selectedAddressEdit}
                                setUserAddress={setUserAddress}
                                isCashier={cart.customer?.is_cashier ?? '0'}
                            />
                        </Modal.Body>
                    </Modal>
                    <Modal show={modalPickUp} backdrop='static' keyboard={false} size="lg" onHide={closePickUp} centered>
                        <Modal.Header className="h5" closeButton>
                            RUDRUNNER
                        </Modal.Header>
                        <Modal.Body>
                            <Container className='mt-2 pb-3' fluid='sm'>
                                <Row className="d-flex justify-content-center" >
                                    <Col xl={10} lg={12} md={12}>
                                        <div className="h3 text-uppercase">Disclaimer</div>
                                        <div style={{ textAlign: 'justify' }} className="mb-4">
                                            <p>
                                                By clicking the button below, you <b>AGREE</b> to proceed with Pick Up in Store at <b>{warehouseDetailData[pickUpWarehouse]?.name}</b>, {capitalizeWords(formatIndonesianCity(warehouseDetailData[pickUpWarehouse]?.city || 'Unknown City'))}, and acknowledge all associated terms and conditions. The items must be collected within <b>2 x 24 hours</b> after payment completion. Failure to do so may result in the loss or damage of the items, for which <b>Rudrunner will not be held responsible</b>.
                                            </p>
                                        </div>
                                        <div className="float-end">
                                            <Button
                                                content="OK, Proceed"
                                                icon="arrow alternate circle right"
                                                labelPosition="right"
                                                color="teal"
                                                onClick={() => {
                                                    closePickUp()
                                                    showPay()
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                    </Modal>
                    <Modal show={modalAddressList} onHide={closeAddressList} size='lg' backdrop='static' keyboard={false}>
                        <Modal.Header closeButton>Your Address List</Modal.Header>
                        <Modal.Body className="ps-4 pe-4">
                            {
                                (addressList && selectedAddress) ? (
                                    addressList.map((item, i) => (
                                        <section className="callout" key={i} style={(item.id_address === selectedAddress.id_address) ? { backgroundColor: '#f6f6f6' } : { backgroundColor: '#ffff' }}>
                                            <Row className="d-flex justify-content-start align-items-middle">
                                                <Col lg={10} md={10} sm={10}>
                                                    <span className="fw-bold me-3">{item.address_label}</span>
                                                    <span>{(item.isDefault == 1) ? <Label>Default</Label> : <></>}</span>
                                                    <div>{item.recipient_name}</div>
                                                    <div>{item.celular_number}</div>
                                                    <div>{item.address_detail}</div>
                                                    <div>{item.destination}</div>
                                                    <Button.Group basic className="mt-3">
                                                        <Button
                                                            content="Edit Address"
                                                            onClick={() => {
                                                                setSelectedAddressEdit(item)
                                                                if (setSelectedAddressEdit !== null) {
                                                                    showAddressFormEdit();
                                                                    closeAddressList()
                                                                }
                                                            }}
                                                        />
                                                        {(item.isDefault == 1) ? <></> :
                                                            <Button
                                                                content="Make Default"
                                                                onClick={() => setDefaultAddress(item.id_address, (item.isDefault == 0) ? 1 : 0)} />}
                                                    </Button.Group>
                                                </Col>
                                                <Col lg={2} md={2} sm={2} className="d-flex justify-content-end align-self-center">
                                                    {(item.id_address === selectedAddress.id_address) ?
                                                        <FontAwesomeIcon className="text-muted fs-5" icon={faCheck} /> :
                                                        <Button content="Select"
                                                            onClick={() => {
                                                                setUsedAddress(addressList, item.id_address)
                                                                unSetAllCourierData()
                                                                closeAddressList()
                                                                updateOrderAddress(cart.summary.order_id, item.id_address)
                                                                setAddrChange(true)
                                                            }} />}
                                                </Col>
                                            </Row>
                                        </section>
                                    ))
                                ) : <>No data</>
                            }
                            <Row>
                                <Col>
                                    {
                                        addressState.allow ?
                                            <Button
                                                content="Add New Address"
                                                fluid
                                                basic
                                                onClick={() => {
                                                    showAddressForm()
                                                    closeAddressList()
                                                }} />
                                            :
                                            <div className="text-muted border p-2 text-center small rounded"><i>Can't add more address, limited {addressState.limit} addresses per customer</i></div>
                                    }
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>
                    <Modal show={modalService} onHide={() => handleHideCourier()} backdrop='static' keyboard={false} centered>
                        <Modal.Header closeButton className="fs-5 fw-bold">Select Courier Services</Modal.Header>
                        <Modal.Body style={{ backgroundColor: 'whitesmoke' }}>
                            {/* <Dimmer active={courierLoader} inverted>
                                <Loader inverted>Loading</Loader>
                            </Dimmer> */}
                            <Row className="mb-3">
                                <Col
                                    style={{
                                        backgroundColor: 'white',
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        borderRadius: 4,
                                        marginRight: 10,
                                        marginLeft: 10
                                    }}
                                >
                                    <Stack direction="horizontal" gap={2}>
                                        <div style={{ backgroundColor: 'whitesmoke', borderRadius: 4, border: 'solid 1px lightgrey', padding: '5px' }}>
                                            <img src={(selKurir) ? selKurir.logo : <></>} width={32} height={32}></img>
                                        </div>
                                        <div>
                                            <div className="fw-bold">{(selKurir) ? selKurir.name : (orderCourier) ? orderCourier.name : <></>}</div>
                                            <div>{(selKurir) ? selKurir.description : (orderCourier) ? orderCourier.description : <></>}</div>
                                            <div className="small">{(disabledClick) ? "Please wait until shipping calculation has been done" : <></>}</div>
                                        </div>
                                    </Stack>
                                </Col>
                            </Row>
                            <Row>
                                <Col
                                    style={{
                                        backgroundColor: '#fff',
                                        marginRight: 10,
                                        marginLeft: 10,
                                        borderRadius: 4
                                    }}
                                >
                                    <ListGroup variant="flush">
                                        {
                                            (courierServices) && !disabledClick ?
                                                courierServices.price.map((item, i) => (
                                                    <ListGroup.Item
                                                        // onClick={() => handleClickService(item, cart)}
                                                        onClick={() => handleClickService(item, cart, modalWarehouse)}
                                                        style={{ pointerEvents: disabledClick ? 'none' : 'auto', opacity: disabledClick ? 0.5 : 1 }}
                                                        key={i}
                                                    >
                                                        <Row style={{ cursor: 'pointer' }}>
                                                            <Col sm={11}>
                                                                <div className="fw-bold">{item.service_display}</div>
                                                                <div className="me-2">
                                                                    {(cart.summary.voucher_ongkir > 0 && item.price > cart.summary.voucher_ongkir) ?
                                                                        <Stack direction="horizontal" gap={3}>
                                                                            <div className="text-muted">Estimated {item.etd_from} - {item.etd_thru} day</div>
                                                                            {/* {(item.price > cart.summary.voucher_ongkir) ? global.IDR.format(item.price - cart.summary.voucher_ongkir) : global.IDR.format(item.price)} <del>{global.IDR.format(item.price)}</del> */}
                                                                            <div>{global.IDR.format(item.price)}</div>
                                                                        </Stack> :
                                                                        (cart.summary.voucher_ongkir > 0 && item.price < cart.summary.voucher_ongkir) ?
                                                                            <Stack direction="horizontal" gap={2}>
                                                                                <div className="text-muted">Estimated {item.etd_from} - {item.etd_thru} day</div>
                                                                                {/* <div>{global.IDR.format(item.price - item.price)} &nbsp; <del>{global.IDR.format(item.price)}</del></div> */}
                                                                                <div>{global.IDR.format(item.price)}</div>
                                                                            </Stack>
                                                                            :
                                                                            <Stack direction="horizontal" gap={2}>
                                                                                <div className="text-muted">Estimated {item.etd_from} - {item.etd_thru} day</div>
                                                                                <div>{global.IDR.format(item.price)}</div>
                                                                            </Stack>

                                                                    }
                                                                </div>
                                                                {/* <span className="text-muted">Estimated {item.etd_thru} day</span> */}
                                                            </Col>
                                                            <Col sm={1} className="text-end d-flex align-content-center flex-wrap fs-5 justify-content-md-center" >
                                                                {
                                                                    (service) ? (
                                                                        (item.service_code === service.service_code && warehouseClicked[courierServices.id_warehouse]) ? <FontAwesomeIcon className="text-muted" icon={faCheck} /> : <FontAwesomeIcon className="text-light" icon={faCheck} />
                                                                    ) : <></>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                )) : <div className="text-center m-3"><Icon name="spinner" loading /></div>
                                        }
                                    </ListGroup>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button 
                                onClick={() => handleClose()} 
                                color="black" 
                                basic
                                content={ !courierListPicked ? 'Please select at last one service!' : 'Apply Selected Service'}
                                disabled={courierServices === null || typeof courierServices.price === 'undefined' || disabledClick || !courierListPicked}
                            />
                        </Modal.Footer>
                    </Modal>
                    <Modal show={modalAddress} onHide={closeAddressForm} backdrop='static' keyboard={false} centered >
                        <Modal.Header closeButton>Add Address</Modal.Header>
                        <Modal.Body>
                            <AddressForm showModal={setModalAddress} getUserAddress={getCustomerAddress} isFirstAddress={true} />
                        </Modal.Body>
                    </Modal>
                    <Modal show={modalPayment} onHide={closePay} backdrop='static' keyboard={false} centered style={{ backgroundColor: 'rgb(0,10,20,0.7)' }}>
                        <Modal.Header closeButton className="fs-5 fw-bold">Payment</Modal.Header>
                        <Modal.Body className="ps-0 pe-0" style={{ backgroundColor: 'whitesmoke' }}>
                            <Row className="ms-3 me-3 pt-2 pb-2 mb-3 rounded" style={{ backgroundColor: '#ffff' }}>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <div className="fw-bold">Payment Method</div>
                                    <ListGroup variant='flush'>
                                        {
                                            payment.data.map((item, i) => (
                                                item.is_active == 'Y' ?
                                                    <ListGroup.Item
                                                        onClick={() => {
                                                            setPaymentSelect(item)
                                                            localStorage.setItem('payment', JSON.stringify(item))
                                                        }}
                                                        key={i}
                                                    >
                                                        <Row style={{ cursor: 'pointer' }}>
                                                            <Col sm={11} xs={10}>
                                                                <Stack direction="horizontal" gap={2}>
                                                                    <div>{item.logo}</div>
                                                                    <div>
                                                                        <div className="fw-bold">{item.name}</div>
                                                                        <div className="text-muted">{item.type}</div>
                                                                    </div>
                                                                </Stack>
                                                            </Col>
                                                            <Col sm={1} xs={2} className="text-end d-flex align-content-center flex-wrap fs-5">
                                                                {
                                                                    (paymentSelect !== null) ? (
                                                                        (paymentSelect.id === item.id) ? <FontAwesomeIcon className="text-muted" icon={faCheck} /> : <FontAwesomeIcon className="text-light" icon={faCheck} />
                                                                    ) : <></>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                    : <></>
                                            ))
                                        }
                                    </ListGroup>
                                </Col>
                            </Row>
                            <Row className="ms-3 me-3 pt-2 pb-2 rounded" style={{ backgroundColor: '#ffff' }}>
                                <div className="fw-bold mb-2">Payment Summary</div>
                                <Col sm={8} xs={8} className="text-muted">
                                    <div>Transaction Totals ({(cart.summary.totalItem) ? cart.summary.totalItem : 0} item)</div>
                                    {(cart.summary.voucher > 0) ? <div>Voucher </div> : <></>}
                                    {/* <div>Shipping Cost - {(selKurir) ? selKurir.name : (orderCourier) && orderCourier.name}&nbsp;{(service) ? service.service_display : <></>}</div> */}
                                    {!isPickUp && (
                                        <>
                                            <div>Shipping Cost - {(selKurir) ? selKurir.name : (orderCourier) && orderCourier.name}&nbsp;{(selCompleteCourier?.service) ? `(${selCompleteCourier.service?.service_display}.)` : <></>}</div>
                                            {/* {(service) ? cart.summary.voucher_ongkir > 0 && service.price > cart.summary.voucher_ongkir ? <>Shipping Disc.</> : <></> : <></>} */}
                                            {/* {cart.summary.voucher_ongkir > 0 && selCompleteCourier.service?.price > cart.summary.voucher_ongkir ? <>Shipping Disc.</> : <></>} */}
                                            <div className="text-muted">Shipping Insurance</div>
                                        </>
                                    )}
                                </Col>
                                <Col sm={4} xs={4} className="text-dark px-2">
                                    <div className="text-end">{global.IDR.format(cart.summary.totalPrice)}</div>
                                    {(cart.summary.voucher > 0) ? <div className="text-end">{global.IDR.format(cart.summary.voucher)}</div> : <></>}
                                    {/* <div className="text-end">{(service) ? service.price >= cart.summary.voucher_ongkir ? global.IDR.format(service.price) : <del>{global.IDR.format(service.price)}</del> : 'Rp 0'}</div> */}
                                    {!isPickUp && (
                                        <>
                                            <div className="text-end">
                                                {
                                                    (selCompleteCourier?.service) ? selCompleteCourier.service?.price >= cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0 ?
                                                        <>
                                                            <del><small>{global.IDR.format(selCompleteCourier.service?.price)}</small></del>&nbsp;
                                                            {global.IDR.format((selCompleteCourier.service?.price - cart.summary.voucher_ongkir))}
                                                        </> :
                                                        selCompleteCourier.service?.price < cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0 ?
                                                            <>
                                                                <del><small>{global.IDR.format(selCompleteCourier.service?.price)}</small></del>&nbsp;{global.IDR.format(0)}
                                                            </> : selCompleteCourier.service?.price > 0 ? global.IDR.format(selCompleteCourier.service?.price) : 'Rp 0'
                                                        : 'Rp 0'
                                                }
                                            </div>
                                            {/* <div className="text-end">
                                                <span style={{color:'#00B5AD'}}>
                                                    {
                                                        (cart.summary.voucher_ongkir > 0) ? 
                                                            `(-${global.IDR.format(cart.summary.voucher_ongkir)})`
                                                        : ''
                                                    }
                                                </span>
                                            </div> */}
                                            <div className="text-end mb-2">{global.IDR.format(cart.summary.asuransi)}</div>
                                        </>
                                    )}
                                </Col>
                                <div className="text-end"><LabelVoucher /></div>
                            </Row>
                            {cart.customer?.is_cashier === '1' && (
                                <Row style={{ backgroundColor: '#ffff' }} className="mt-3 p-4 ms-3 me-3 rounded">
                                    <h3>Customer Info</h3>
                                    <InfoCustomerForm
                                        cart={cart}
                                        customerId={idCustomer}
                                        isCompletedInputInfo={isCompletedInputInfo}
                                        setIsCompletedInputInfo={setIsCompletedInputInfo}
                                    />
                                </Row>
                            )}
                        </Modal.Body>
                        <Modal.Footer className="ps-0 pe-0">
                            <Row className="w-100">
                                <Col sm={5} xs={5} className="mb-2">
                                    <div className="">Total Bill</div>
                                    <div className="fs-5 fw-bold">{(cart.summary.total_order) ? global.IDR.format(parseFloat(cart.summary.total_order)) : global.IDR.format(0)}</div>
                                </Col>
                                <Col sm={7} xs={7} className="d-flex justify-content-center">
                                    <Button
                                        color="black"
                                        icon="arrow alternate circle right outline"
                                        labelPosition="right"
                                        fluid
                                        loading={isLoad}
                                        disabled={cart.customer?.is_cashier === '1' && !isCompletedInputInfo}
                                        content="Pay Now"
                                        onClick={() => {
                                            if ((cart.summary.total_order) && (parseFloat(cart.summary.total_order) <= 0)) {
                                                alert('Please wait untill the calculation is done')
                                            } else if (!paymentSelect) {
                                                alert('No payment method selected')
                                            } else {
                                                if (paymentSelect.id === '001') {
                                                    createPayment(idCustomer)
                                                } else if (paymentSelect.id === '002') {
                                                    createPaymentCC(idCustomer)
                                                } else if (paymentSelect.id === '003') {
                                                    createSnapPay(idCustomer)
                                                }
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Modal>
                    <Row className="pb-4 text-start" style={{ marginTop: '7%' }}>
                        <Col>
                            <Alert variant="secondary" show={payAlert} onClose={hidePayAlert} dismissible>
                                {paymentRes}
                            </Alert>
                        </Col>
                        <div className="mt-5 mb-2">
                            <div className="me-2 mb-2 fs-5 fw-bold">
                                {isLoadingPickUp ? (
                                    <section className='mb-3'>
                                        <span className='me-4'>
                                            <Placeholder style={{ width: '20rem', height: '2rem' }}>&nbsp;</Placeholder>
                                        </span>
                                    </section>
                                ) : (
                                    isPickUp ? <><FontAwesomeIcon style={{ color: '#00B5AD' }} icon={faStore} className="me-2" /> Pick Up in Store Checkout</> : <><FontAwesomeIcon style={{ color: '#00B5AD' }} icon={faTruck} className="me-2" /> Delivery Order Checkout</>
                                )}
                            </div>
                            {
                                (cart.summary.expiry_time) &&
                                <div className="text-muted fw-bold">
                                    <span>Finish your order on </span>
                                    <span style={{ color: '#00B5AD' }}>
                                        <TimerCountDown
                                            expiryTime={new Date(cart.summary.expiry_time)}
                                            sendTime={true}
                                            setCurentTime={setCurrentTime}
                                        // cancelOnExpire={cancelOnExpire}
                                        />
                                    </span>
                                </div>
                            }
                        </div>

                        <Col lg={8} md={8} sm={12} className="mb-4">
                            {!isPickUp && !isLoadingPickUp && (
                                <Card className="mb-4">
                                    {/* <Card.Header><h4>Shipping Address</h4></Card.Header> */}
                                    <Card.Body>
                                        <h4><Icon name="map marker alternate" color="teal" />&nbsp;Shipping Address</h4>
                                        {(userAddress) ?
                                            <section>
                                                <div className="fw-bold mb-3"><Label color="teal" size="mini" tag> {userAddress.address_label} </Label></div>
                                                <div className="fw-bold">{userAddress.recipient_name}</div>
                                                <div>{userAddress.celular_number}</div>
                                                <div className="text-muted">{userAddress.address_detail}</div>
                                                <div className="">{userAddress.destination}</div>
                                                <hr />
                                                <Button color="black" icon="map marker alternate" content='Other Address' onClick={() => showAddressList()} />
                                            </section>

                                            :
                                            <>
                                                <Button color="teal" content="Add Address" onClick={() => showAddressForm()} />
                                            </>}

                                    </Card.Body>
                                </Card>
                            )}
                            {isPickUp && !isLoadingPickUp && (
                                <Card className="mb-4">
                                    {/* <Card.Header><h4>Shipping Address</h4></Card.Header> */}
                                    <Card.Body>
                                        <h4>
                                            <Icon name="map marker alternate" color="teal" />&nbsp;Showroom Address
                                        </h4>
                                        <section>
                                            <div className="fw-bold">{`${warehouseDetailData[pickUpWarehouse]?.name} (${warehouseDetailData[pickUpWarehouse]?.alias})`}</div>
                                            <div>{warehouseDetailData[pickUpWarehouse]?.phone ? warehouseDetailData[pickUpWarehouse]?.phone : 'No Phone Number found'}</div>
                                            <div className="text-muted">
                                                {warehouseDetailData[pickUpWarehouse]?.address}
                                            </div>
                                            <div className="">{warehouseDetailData[pickUpWarehouse]?.city}, {warehouseDetailData[pickUpWarehouse]?.prov}</div>
                                        </section>
                                    </Card.Body>
                                </Card>
                            )}
                            {!hasWarehouse && (
                                <Card>
                                    {/* <Card.Header><h4>Products</h4></Card.Header> */}
                                    <Card.Body>
                                        <Row>
                                            <Col lg={8} md={8} sm={12}>
                                                <h4><Icon name="box" color="teal" />&nbsp;Products</h4>
                                                <ListGroup variant="flush" numbered>
                                                    {
                                                        cart.products.map((item, i) => {
                                                            return (
                                                                <ListGroup.Item as="li" key={i} className="d-flex justify-content-start align-items-start">
                                                                    {
                                                                        <section className="d-flex justify-content-start align-items-start">
                                                                            <div style={{ width: 100, height: 90 }} className="ms-2 me-3">
                                                                                <Image
                                                                                    src={item.product_image ? item.product_image.image : "https://via.placeholder.com/500x400.png"}
                                                                                    alt={item.product_name}
                                                                                    height={90}
                                                                                    width={110}
                                                                                    rounded
                                                                                    className="border"
                                                                                />
                                                                            </div>
                                                                            <div className="ms-3">
                                                                                <div className="fw-bold text-wrap mb-2" style={{ cursor: 'pointer', color: '#00B5AD' }} onClick={() => handleClickProduct(item)}>{item.product_name}</div>
                                                                                <div>{item.id_product}</div>
                                                                                <div className="mb-2">
                                                                                    <span className="me-3 fw-bold text-truncate">{global.IDR.format(item.multiple_disc_price > 0 ? item.multiple_disc_price : item.final_price)}&nbsp;&nbsp;(x{item.qty})</span>
                                                                                    <span className="text-muted">{priceCoret(item)}</span>
                                                                                </div>
                                                                                <div className="mb-2">
                                                                                    {calcDiscPercent(item)}
                                                                                    {calcDiscPercent(item) !== undefined && multipleDiscLabel(item) !== undefined ? ' | ' : ''}
                                                                                    {multipleDiscLabel(item)}
                                                                                    {/* <span><small>{calcDiscValue(item)}</small></span> */}
                                                                                </div>
                                                                                <div>
                                                                                    {
                                                                                        item.included_on_voucher &&
                                                                                        item.included_on_voucher.map((item, i) => (
                                                                                            <Popup trigger={
                                                                                                <div className='fw-bold' style={{ color: '#F7634C', fontSize: '0.8em' }}>
                                                                                                    <Icon name='tag' />
                                                                                                    {item.name} -{item.type == 'D' ? item.percent : item.nominal}% off
                                                                                                </div>
                                                                                            }
                                                                                                size='mini'
                                                                                                content={`This item is included in the voucher ${item.name}`}
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                                <div>
                                                                                    <span className='me-3 text-muted'>Weight : {item.product_dimension.weight} kg</span>
                                                                                    <span className='me-3 text-muted'>Size : {item.selected_size}</span>
                                                                                    <span className='me-3 text-muted'>Color :</span>
                                                                                    <span>
                                                                                        <canvas className='border-start border-top border-bottom border-dark' width={10} height={10} style={{ backgroundColor: item.selected_color.color_main }} key={1} />
                                                                                        <canvas className='border-top border-bottom border-dark' width={10} height={10} style={{ backgroundColor: item.selected_color.color_secondary }} key={2} />
                                                                                        <canvas className='border-end border-top border-bottom border-dark' width={10} height={10} style={{ backgroundColor: item.selected_color.color_accent }} key={3} />
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </section>
                                                                    }
                                                                </ListGroup.Item>
                                                            )
                                                        })
                                                    }
                                                </ListGroup>
                                            </Col>
                                            {!isPickUp && (
                                                <Col>
                                                    <h4><Icon name="shipping fast" color="teal" />&nbsp;Delivery</h4>
                                                    <Popup
                                                        size="mini"
                                                        position={cart.customer.address !== null ? "top right" : "bottom left"}
                                                        content={cart.customer.address !== null ? "Select some courier" : <div style={{ color: '#da7d13' }}>No address selected..!</div>}
                                                        trigger={
                                                            <DropdownButton
                                                                flip
                                                                variant="outline-dark"
                                                                className={cart.customer.address !== null ? "d-grid" : "d-grid shaked"}
                                                                title={courierOptLabel}
                                                                disabled={cart.customer.address == null ? true : false}
                                                            >
                                                                {
                                                                    (courier !== null) ? (
                                                                        courier.map((item, i) => (
                                                                            <Dropdown.Item
                                                                                eventKey={i}
                                                                                key={i}
                                                                                onClick={() => handleClickDropdown(item, cart)}
                                                                            // onClick={() => handleClickWithDelay(item, cart)}
                                                                            >
                                                                                <div className="fw-bold" style={{ color: '#00B5AD' }}>{item.name}</div>
                                                                                <div className="text-muted">{item.description}</div>
                                                                            </Dropdown.Item>
                                                                        ))
                                                                    ) : (<div className="text-center" style={{ color: '#00B5AD' }}>No Courier</div>)

                                                                }
                                                            </DropdownButton>
                                                        } />
                                                    <section>
                                                        {/* <SelectedCourier kurir={selKurir} selService={service} /> */}
                                                        {
                                                            (selKurir && service) ?
                                                                <section className="mt-2">
                                                                    <div className="fw-bold">Selected Courier</div>
                                                                    <div style={{ color: '#00B5AD' }}>{selKurir.name}</div>
                                                                    <div className="fw-bold">Service</div>
                                                                    <div className="d-flex justify-content-between" style={{ color: '#00B5AD' }}>
                                                                        {(cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0 && service.price > cart.summary.voucher_ongkir) ?
                                                                            <span>{(service) ? service.service_display : <></>} &nbsp;&nbsp; {(service) ? global.IDR.format(service.price - cart.summary.voucher_ongkir) : <></>}</span>
                                                                            :
                                                                            (cart.summary.voucher_ongkir > 0 && service.price < cart.summary.voucher_ongkir) ?
                                                                                <span>{(service) ? service.service_display : <></>} &nbsp;&nbsp; {(service) ? global.IDR.format(service.price - service.price) : <></>}</span>
                                                                                :
                                                                                <span>{(service) ? service.service_display : <></>} &nbsp;&nbsp; {(service) ? global.IDR.format(service.price) : <></>}</span>
                                                                        }
                                                                        {/* <span className="fw-bold" onClick={handleShow} style={{ cursor: 'pointer' }}>Change</span> */}
                                                                    </div>
                                                                </section>
                                                                :
                                                                orderCourier ?
                                                                    <section className="mt-2">
                                                                        <div className="fw-bold">Selected Courier</div>
                                                                        <div className="text-muted">{orderCourier.name}</div>
                                                                        <div className="fw-bold">Service</div>
                                                                        <div className="text-muted d-flex justify-content-between">
                                                                            {
                                                                                <span>{orderCourier.service_display} &nbsp;&nbsp; {global.IDR.format(orderCourier.courier_cost)}</span>
                                                                            }

                                                                            {/* <span className="fw-bold" onClick={() => alert('ssss')} style={{ cursor: 'pointer' }}>Change</span> */}
                                                                        </div>
                                                                    </section>
                                                                    :
                                                                    <></>
                                                        }
                                                    </section>
                                                </Col>
                                            )}
                                        </Row>
                                        <Row>
                                            <Col md={12}><hr /></Col>
                                            <Col md={6}>
                                                <Button color="black" icon="ban" content="Cancel This Order" disabled={btnCclState}
                                                    onClick={() => handleCancel(idCustomer)}
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>)}
                            {hasWarehouse && (
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <h4>
                                                    <Icon name="box" color="teal" /> Products
                                                </h4>
                                                <Accordion fluid>
                                                    {Object.entries(groupedProducts).map(([warehouseId, items], groupIndex) => (
                                                        <div key={warehouseId} className="mb-4">
                                                            <Accordion.Title
                                                                active={activeIndices.includes(groupIndex)}
                                                                index={groupIndex}
                                                                onClick={() => handleAccordionClick(groupIndex)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '1.2rem',
                                                                    paddingBottom: '0.5rem',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <Icon name={activeIndices.includes(groupIndex) ? 'angle down' : 'angle right'} color="teal" />
                                                                <span style={{ marginLeft: '0.5rem' }} className="py-1 text-secondary">
                                                                    <h5>
                                                                        Warehouse: {warehouseDetailData[warehouseId]?.name || 'Rudrunner Online'}, {formatIndonesianCity((capitalizeWords(warehouseDetailData[warehouseId]?.city || 'Kota Bandung')))}
                                                                    </h5>
                                                                </span>
                                                            </Accordion.Title>

                                                            <Accordion.Content active={activeIndices.includes(groupIndex)}>
                                                                <Row>
                                                                    <Col lg={!isPickUp ? '8' : '12'} md={!isPickUp ? '8' : '12'} sm={12}>
                                                                        {items.map((item, index) => (
                                                                            <ListGroup.Item as="li" key={index} className="d-flex justify-content-start align-items-start mb-2">
                                                                                <section className="d-flex">
                                                                                    <div style={{ width: 100, height: 90 }} className="ms-2 me-3">
                                                                                        <Image
                                                                                            src={item.product_image?.image || "https://via.placeholder.com/500x400.png"}
                                                                                            alt={item.product_name}
                                                                                            height={90}
                                                                                            width={110}
                                                                                            rounded
                                                                                            className="border"
                                                                                        />
                                                                                    </div>
                                                                                    <div className="ms-3">
                                                                                        <div
                                                                                            className="fw-bold text-wrap mb-2"
                                                                                            style={{ cursor: 'pointer', color: '#00B5AD' }}
                                                                                            onClick={() => handleClickProduct(item)}
                                                                                        >
                                                                                            {item.product_name}
                                                                                        </div>
                                                                                        <div>{item.id_product}</div>
                                                                                        <div className="mb-2">
                                                                                            <span className="me-3 fw-bold text-truncate">
                                                                                                {global.IDR.format(item.multiple_disc_price > 0 ? item.multiple_disc_price : item.final_price)} (x{item.qty})
                                                                                            </span>
                                                                                            <span className="text-muted">{priceCoret(item)}</span>
                                                                                        </div>
                                                                                        <div className="mb-2">
                                                                                            {calcDiscPercent(item)}
                                                                                            {calcDiscPercent(item) !== undefined && multipleDiscLabel(item) !== undefined ? ' | ' : ''}
                                                                                            {multipleDiscLabel(item)}
                                                                                        </div>
                                                                                        <div>
                                                                                            {item.included_on_voucher?.map((voucher, i) => (
                                                                                                <Popup
                                                                                                    key={i}
                                                                                                    trigger={
                                                                                                        <div className="fw-bold" style={{ color: '#F7634C', fontSize: '0.8em' }}>
                                                                                                            <Icon name="tag" />
                                                                                                            {voucher.name} - {voucher.type === 'D' ? `${voucher.percent}%` : `${voucher.nominal} off`}
                                                                                                        </div>
                                                                                                    }
                                                                                                    size="mini"
                                                                                                    content={`This item is included in the voucher ${voucher.name}`}
                                                                                                />
                                                                                            ))}
                                                                                        </div>
                                                                                        <div>
                                                                                            <span className="me-3 text-muted">Weight: {item.product_dimension.weight} kg</span>
                                                                                            <span className="me-3 text-muted">Size: {item.selected_size}</span>
                                                                                            <span className="me-3 text-muted">Color:</span>
                                                                                            <span>
                                                                                                <canvas className="border-start border-top border-bottom border-dark" width={10} height={10} style={{ backgroundColor: item.selected_color.color_main }} />
                                                                                                <canvas className="border-top border-bottom border-dark" width={10} height={10} style={{ backgroundColor: item.selected_color.color_secondary }} />
                                                                                                <canvas className="border-end border-top border-bottom border-dark" width={10} height={10} style={{ backgroundColor: item.selected_color.color_accent }} />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </section>
                                                                            </ListGroup.Item>
                                                                        ))}
                                                                    </Col>
                                                                    {!isPickUp && (
                                                                        <Col className="mt-4 mt-lg-0">
                                                                            <h4><Icon name="shipping fast" color="teal" /> Delivery</h4>
                                                                            <Popup
                                                                                size="mini"
                                                                                position={cart.customer.address !== null ? "top right" : "bottom left"}
                                                                                content={cart.customer.address !== null ? "Select some courier" : <div style={{ color: '#da7d13' }}>No address selected..!</div>}
                                                                                trigger={
                                                                                    <DropdownButton
                                                                                        flip
                                                                                        variant="outline-dark"
                                                                                        className={cart.customer.address !== null ? "d-grid" : "d-grid shaked"}
                                                                                        title={warehouseClicked[warehouseId] ? 'Change Courier' : 'Available Courier'}
                                                                                        disabled={cart.customer.address == null}
                                                                                    >
                                                                                        {(courier !== null) ? (
                                                                                            courier.map((item, i) => (
                                                                                                <Dropdown.Item
                                                                                                    eventKey={i}
                                                                                                    key={i}
                                                                                                    // onClick={() => handleClickDropdown(item, cart, warehouseId, warehouseWeight[warehouseId])}
                                                                                                    onClick={() => handleClickWithDelay(item, cart, warehouseId, warehouseWeight[warehouseId])}
                                                                                                >
                                                                                                    <div className="fw-bold" style={{ color: '#00B5AD' }}>{item.name}</div>
                                                                                                    <div className="text-muted">{item.description}</div>
                                                                                                </Dropdown.Item>
                                                                                            ))
                                                                                        ) : (
                                                                                            <div className="text-center" style={{ color: '#00B5AD' }}>No Courier</div>
                                                                                        )}
                                                                                    </DropdownButton>
                                                                                }
                                                                            />
                                                                            {courierPerWarehouse[warehouseId]?.is_clicked && (
                                                                                <section className="mt-2">
                                                                                    <div className="fw-bold">Selected Courier</div>
                                                                                    <div className="text-muted">{selKurir.name}</div>
                                                                                    <div className="fw-bold">Service</div>
                                                                                    <div className="text-muted d-flex justify-content-between">
                                                                                        <span>{courierPerWarehouse[warehouseId].service_display} &nbsp;&nbsp; {global.IDR.format(courierPerWarehouse[warehouseId].price)}</span>
                                                                                    </div>
                                                                                </section>
                                                                            )}
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            </Accordion.Content>
                                                        </div>
                                                    ))}
                                                </Accordion>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}><hr /></Col>
                                            <Col md={6}>
                                                <Button
                                                    color="black"
                                                    icon="ban"
                                                    content="Cancel This Order"
                                                    disabled={btnCclState || cancelLoad}
                                                    loading={btnCclState || cancelLoad}
                                                    onClick={() => handleCancel(idCustomer)}
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )
                            }
                        </Col>
                        <Col lg={4} md={4} sm={12}>
                            <SummaryCart
                                cart={cart}
                                totalItem={cart.summary.totalItem}
                                totalPrice={cart.summary.totalPrice}
                                url={null}
                                label={'Select Payment'}
                                setModalPayment={setModalPayment}
                                customerAddress={userAddress}
                                page="checkout"
                                courier={selCompleteCourier}
                                completeSelectedCourier={isEnableClickPayment}
                                isUpdate={!isPickUp ? !isEnableClickPayment : false}
                                detailCourier={courierPerWarehouse}
                                pendingCourier={!isPickUp && !isEnableClickPayment ? isLoadingCart ? 'Please Wait' : 'Please Select all Courier' : ''}
                                isPickUp={isPickUp}
                                setModalPickUp={setModalPickUp}
                            />
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Container fluid='sm'>
                    <Row style={{ height: '65vh' }}>
                        <Col className="d-flex align-items-center justify-content-center">
                            <span className="fs-5">There is nothing here, please come back</span>
                        </Col>
                    </Row>
                </Container>
            )
            }
        </section>
    )
}

export default Checkout;